export const STATUS = {
  PENDING: 'PENDING',
  DONE: 'DONE',
  ERROR: 'ERROR',
};
